<!-- Print Tour Popup -->
<div class="popup-overlay" [class.show]="visible" (click)="close()">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h4 class="popup-title">
        <i class="fas fa-print me-2"></i>
        Stampa Tour
      </h4>
      <button type="button" class="btn-close" (click)="close()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <div class="row">
        <div class="col" style="flex: 0 0 60%; max-width: 60%;">
          <label class="form-label">Seleziona Tour da Stampare:</label>
          
          <!-- Select ricercabile multiplo con salvataggio delle selezioni (stesso componente dei filtri) -->
          <app-searchable-select
              [ngModel]="selectedToursForPrint"
              (valueChange)="onToursSelectChange($event)"
              [options]="tourSelectOptions"
              [multiple]="true"
              [disabled]="isPrintingTour"
              allOptionLabel="0 tour selezionati"
              icon="fas fa-route"
              searchPlaceholder="Cerca tour..."
              savedSelectionsKey="shipment-management.tours-print">
          </app-searchable-select>
        </div>

        <div class="col" style="flex: 0 0 40%; max-width: 40%;">
          <label class="form-label">Seleziona Data del Tour:</label>
          <div class="filter-input-wrapper" [class.disabled-input]="isPrintingTour || selectedToursForPrint.length === 0">
            <i class="fas fa-calendar-day filter-icon"></i>
            <input #tourDateInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedTourDate()"
                   (click)="openTourDatePicker()"
                   (focus)="openTourDatePicker()"
                   readonly
                   placeholder="Data del tour">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn"
                      (click)="decrementTourDate()"
                      [disabled]="isPrintingTour || selectedToursForPrint.length === 0"
                      title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn"
                      (click)="setTourDateToday()"
                      [disabled]="isPrintingTour || selectedToursForPrint.length === 0"
                      title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn"
                      (click)="incrementTourDate()"
                      [disabled]="isPrintingTour || selectedToursForPrint.length === 0"
                      title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn"
                      (click)="clearTourDate()"
                      [disabled]="isPrintingTour || selectedToursForPrint.length === 0"
                      title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Selected Tours List - Full Width -->
      <div class="row mt-3" *ngIf="selectedToursWithOrder.length > 0">
        <div class="col-12">
          <div class="selected-tours-chips">
            <div *ngFor="let selectedTour of selectedToursWithOrder" class="tour-chip">
              <span class="chip-order">{{ selectedTour.selectionOrder }}</span>
              <span class="chip-name">{{ selectedTour.tour }}</span>
              <span class="chip-close"
                    (mousedown)="removeTourFromSelection(selectedTour.tour)"
                    title="Rimuovi">
                <i class="fas fa-times" style="pointer-events: none;"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Summary Cards -->
      <div class="row g-3 mt-2">
        <!-- Numero Bolle -->
        <div class="col-6">
          <div class="summary-card d-flex align-items-center p-3 bg-primary bg-opacity-10 rounded">
            <div class="flex-shrink-0">
              <i class="fas fa-file-alt fa-2x text-primary"></i>
            </div>
            <div class="flex-grow-1 ms-3">
              <div class="fw-bold text-primary fs-4">
                <span *ngIf="selectedToursForPrint.length === 0">-</span>
                <span *ngIf="selectedToursForPrint.length > 0 && isLoadingSummary">
                  <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                </span>
                <span *ngIf="selectedToursForPrint.length > 0 && !isLoadingSummary && allTourClients.length > 0 && totalReWaybills > 0 && printReWaybills">
                  {{ totalWaybills + totalReWaybills | number }} <span style="font-size: 0.65em; font-weight: 500;">cui {{ totalWaybills | number }} Bolle e {{ totalReWaybills | number }} Ribollettazioni</span>
                </span>
                <span *ngIf="selectedToursForPrint.length > 0 && !isLoadingSummary && allTourClients.length > 0 && (totalReWaybills === 0 || !printReWaybills)">
                  {{ totalWaybills | number }}
                </span>
                <span *ngIf="selectedToursForPrint.length > 0 && !isLoadingSummary && allTourClients.length === 0">-</span>
              </div>
              <div class="text-muted small">Numero Bolle</div>
            </div>
          </div>
        </div>

        <!-- Numero Colli -->
        <div class="col-6">
          <div class="summary-card d-flex align-items-center p-3 bg-primary bg-opacity-10 rounded">
            <div class="flex-shrink-0">
              <i class="fas fa-cube fa-2x text-primary"></i>
            </div>
            <div class="flex-grow-1 ms-3">
              <div class="fw-bold text-primary fs-4">
                <span *ngIf="selectedToursForPrint.length === 0">-</span>
                <span *ngIf="selectedToursForPrint.length > 0 && isLoadingSummary">
                  <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                </span>
                <span *ngIf="selectedToursForPrint.length > 0 && !isLoadingSummary && allTourClients.length > 0">
                  {{ totalParcels | number }}
                </span>
                <span *ngIf="selectedToursForPrint.length > 0 && !isLoadingSummary && allTourClients.length === 0">-</span>
              </div>
              <div class="text-muted small">Numero Colli</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Select clienti: disponibile quando il riepilogo è arrivato dal backend -->
      <div class="row mt-3" *ngIf="selectedToursForPrint.length > 0 && !isLoadingSummary && clientSelectOptions.length > 0">
        <div class="col-12">
          <label class="form-label">Seleziona Clienti da Stampare:</label>
          <app-searchable-select
              [ngModel]="selectedClientCodes"
              (valueChange)="onClientsSelectChange($event)"
              [options]="clientSelectOptions"
              [multiple]="true"
              [disabled]="isPrintingTour"
              allOptionLabel="Nessun cliente selezionato"
              icon="fas fa-users"
              searchPlaceholder="Cerca cliente..."
              savedSelectionsKey="shipment-management.tours-print.clients">
          </app-searchable-select>
        </div>
      </div>

      <!-- Client List grouped by Tour -->
      <div class="mt-3" *ngIf="selectedToursForPrint.length > 0">
        <label class="form-label">Clienti per Tour:</label>
        <div class="client-list-container">
          <div *ngIf="isLoadingSummary" class="text-center py-3">
            <span class="spinner-border spinner-border-sm text-primary me-2" role="status" aria-hidden="true"></span>
            <span class="text-muted">Caricamento clienti...</span>
          </div>

          <div *ngIf="!isLoadingSummary && tourSummaries.length > 0">
            <div *ngFor="let tourSummary of tourSummaries; let i = index" class="tour-section" [class.mt-3]="i > 0">
              <!-- Tour Header -->
              <div class="tour-section-header d-flex align-items-center px-2 py-2">
                <span class="tour-section-order me-2">{{ getSelectionOrder(tourSummary.tourName) }}</span>
                <span class="fw-bold">{{ tourSummary.tourName }}</span>
                <span class="text-muted small ms-auto" *ngIf="tourSummary.clients.length > 0">
                  {{ tourSummary.clients.length }} clienti
                </span>
                <span class="text-muted small ms-auto" *ngIf="tourSummary.clients.length === 0">
                  Nessun cliente
                </span>
              </div>
              <!-- Tour Clients -->
              <div class="list-group list-group-flush" *ngIf="tourSummary.clients.length > 0">
                <div class="list-group-item d-flex justify-content-between align-items-center px-2 py-2"
                     *ngFor="let client of tourSummary.clients">
                  <div class="form-check mb-0">
                    <input class="form-check-input" type="checkbox" 
                           [(ngModel)]="client.checked"
                           (ngModelChange)="onClientCheckboxChange()"
                           [id]="'client-' + tourSummary.tourName + '-' + client.clientCode">
                    <label class="form-check-label" [for]="'client-' + tourSummary.tourName + '-' + client.clientCode">
                      <span class="fw-medium">{{ client.clientCode }}</span>
                      <span class="text-muted ms-1" *ngIf="client.clientName">- {{ client.clientName }}</span>
                    </label>
                  </div>
                  <div class="text-end text-muted small">
                    <strong>{{ client.totalWaybills }}</strong> bolle
                    <span *ngIf="client.totalReWaybills > 0"> | <strong>{{ client.totalReWaybills }}</strong> rib.</span>
                    | <strong>{{ client.totalParcels }}</strong> colli
                  </div>
                </div>
              </div>
              <!-- Empty tour -->
              <div *ngIf="tourSummary.clients.length === 0" class="text-muted small text-center py-2 border-bottom">
                Nessun cliente trovato per questo tour
              </div>
            </div>
          </div>

          <div *ngIf="!isLoadingSummary && tourSummaries.length === 0" class="text-muted text-center py-2">
            Nessun dato trovato per i tour selezionati
          </div>
        </div>

        <div class="d-flex align-items-center mt-2 px-2" *ngIf="!isLoadingSummary && allTourClients.length > 0 && totalReWaybills > 0">
          <div class="form-check form-switch mb-0 me-2">
            <input class="form-check-input" type="checkbox" role="switch" id="printReWaybillsToggle" [(ngModel)]="printReWaybills">
          </div>
          <label class="form-label mb-0 small text-muted" for="printReWaybillsToggle">Stampa Bolle Ribollettate</label>
        </div>
      </div>
    </div>

    <div class="popup-footer">
      <button type="button" class="btn btn-secondary" (click)="close()">
        <i class="fas fa-times me-1"></i>
        Annulla
      </button>
      <button type="button"
              class="btn btn-primary"
              [disabled]="selectedToursForPrint.length === 0 || !selectedTourDateForPrint || isPrintingTour"
              (click)="executePrintTour()">
        <span *ngIf="!isPrintingTour">
          <i class="fas fa-print me-1"></i>
          Stampa
        </span>
        <span *ngIf="isPrintingTour">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          Stampa in corso...
        </span>
      </button>
    </div>
  </div>
</div>
